import { UseFormReturn, Controller } from "react-hook-form";
import TextField from "@/components/TextField";
import Button from "@/components/Button";
import classNames from "classnames";

interface CommentsQuotesFormData {
  commentsAndQuotes: string;
}

interface EditCommentsQuotesCardProps {
  form: UseFormReturn<CommentsQuotesFormData>;
  onSubmit: (formData: CommentsQuotesFormData) => void;
  onCancel: () => void;
  isSubmitting: boolean;
}

export default function EditCommentsQuotesCard({
  form,
  onSubmit,
  onCancel,
  isSubmitting
}: EditCommentsQuotesCardProps) {
  return (
    <div className="space-y-6 w-full">
      <div className="col-span-full">
        <Controller
          control={form.control}
          name="commentsAndQuotes"
          render={({ field }) => (
            <TextField
              label="Quotes"
              type="textarea"
              rows={4}
              value={field.value}
              onChange={(e) => field.onChange((e.target as HTMLInputElement)?.value || "")}
              supportingText="Please add any comments/quotes that could be shared with PGA Leadership"
            />
          )}
        />
      </div>
      <div className="flex justify-end gap-2 mt-4">
        <Button variant="outlined" disabled={isSubmitting} onClick={onCancel}>
          Cancel
        </Button>
        <Button
          iconClassName={classNames(isSubmitting && "animate-spin w-6 h-6 !block")}
          disabled={isSubmitting}
          icon={isSubmitting ? "progress_activity" : undefined}
          onClick={() => onSubmit(form.getValues())}
        >
          Save
        </Button>
      </div>
    </div>
  );
}
